import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunkMiddleware from "redux-thunk";
import objectsReducers from "../components/Objects/reducers";
import reviewsReducers from "../components/Reviews/reducers";
import bookingReducers from "../components/Booking/reducers";
import bookingDetailReducers from "../components/BookingDetail/reducers";
import invoicesReducers from "../components/Invoices/reducers";
import userReducers from "../globalState/user/reducers";
import appReducer from "../globalState/app/reducers";
import objectReducers from "../globalState/object/reducers";
import objectRoomEditReducers from "../components/ObjectRoomEdit/reducers";
import subscriberCalendarReducers from "../components/CalendarSubscription/reducers";
import objectAddNewReducers from "../components/ObjectAddNew/reducers";
import busyCalendarReducers from "../components/CalendarBusy/reducers";
import commissionCalendarReducers from "../components/CalendarPercent/reducers";
import contractsDetailReducers from "../components/ContractsDetail/reducers";


let reducers = combineReducers({
    app: appReducer,
    objects: objectsReducers,
    reviewsPage: reviewsReducers,
    bookingsPage: bookingReducers,
    bookingDetailPage: bookingDetailReducers,
    contractsDetailPage: contractsDetailReducers,
    invoicesPage: invoicesReducers,
    user: userReducers,
    object: objectReducers,
    objectAddNew: objectAddNewReducers,
    objectRoomEdit: objectRoomEditReducers,
    subscriberCalendar: subscriberCalendarReducers,
    commissionCalendar: commissionCalendarReducers,
    busyCalendar: busyCalendarReducers,

});


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunkMiddleware)
));


export default store;